import type { LoaderOptions } from '@/loaders/LoaderOptions';

import { getPublicationsQueryOptions, unitByIdQueryOptions } from '@/service/vpc/queryOptions';
import { chassis } from '@/utils';

export const loaderUnitPublicationsPage = async (opts: LoaderOptions) => {
  const { endCustomerUnitId } = opts.params;

  if (!endCustomerUnitId) {
    return;
  }

  // Fetch unit data to extract serial numbers
  const unitData = await opts.context.queryClient.ensureQueryData(unitByIdQueryOptions({ endCustomerUnitId }));

  const serialNumbers = chassis.getUnitSerialNumbers(unitData) || [];

  // Fetch publications data with serial numbers
  const publicationsData = await opts.context.queryClient.ensureQueryData(
    getPublicationsQueryOptions({
      endCustomerUnitId,
      serialNumbers: serialNumbers.length > 0 ? serialNumbers : undefined,
    })
  );

  return { publicationsData, endCustomerUnitId };
};
